export default __webpack_public_path__ + "static/media/logo-horizontall-sin-fondo.20d093e6.png";